<script setup lang="ts">
import type { TableColumn } from "@nuxt/ui";
  
import { computed, h } from "vue";

import { RouterLink } from "vue-router";

import { displayAirportCode } from "@ca/formatters/airports";

import { useAircraftTopMissions } from "@/queries/aircraft";
  
const props = defineProps<{
	aircraftId: string;
}>();
  
  
const { data } = useAircraftTopMissions(() => props.aircraftId);
  
const missions = computed(() => {
	const missionData = data.value ?? [];
    
	// Add rank to each mission
	let currentRank = 1;
	let previousCount = missionData.at(0)?.count ?? 0;
    
	return missionData.map((mission, index) => {
		// If count is different from previous, update the rank
		if (index > 0 && mission.count < previousCount) {
			currentRank = index + 1;
		}
      
		previousCount = mission.count;
      
		return {
			...mission,
			destination: displayAirportCode(mission.destinationAirport),
			origin: displayAirportCode(mission.originAirport),
			rank: currentRank,
		};
	});
});
  
const columns: TableColumn<typeof missions.value[number]>[] = [
	{
		accessorKey: "rank",
		header: "#",
	},
	{
		accessorKey: "origin",
		header: "Origin",
		cell: ({ row }) => {
			const origin = row.original.origin;
			if (!origin) return null;
			return h(RouterLink, {
				to: `/airports/${origin}`,
				class: "hover:underline",
			}, () => origin);
		},
	},
	{
		accessorKey: "destination",
		header: "Destination",
		cell: ({ row }) => {
			const destination = row.original.destination;
			if (!destination) return null;
			return h(RouterLink, {
				to: `/airports/${destination}`,
				class: "hover:underline",
			}, () => destination);
		},
	},
	{
		accessorKey: "count",
		header: "Flight Count",
	},
];
  

</script>
    
<template>
  <div>
    <h3 class="font-cta text-brand-500 text-xl mb-4">
      Top Missions
    </h3>
    <UCard variant="subtle">
      <UTable
        :columns="columns"
        :data="missions"
      />
    </UCard>
  </div>
</template>